export default __webpack_public_path__ + "media/application/assets/images/login-help-13724e16918183f39a96fc821fa018fa.png";